import { createAction, props } from '@ngrx/store';
import { SupplierCreditNoteModel } from '@shared/data-access/models';

export const loadItem = createAction('[SUPPLIER CREDIT NOTE] LOAD ITEM', props<{ id: number }>());
export const loadItemSuccess = createAction('[SUPPLIER CREDIT NOTE] LOAD ITEM SUCCESS', props<{ item: SupplierCreditNoteModel }>());
